import ArvexisPresence from '../components/ArvexisPresence';
import OnboardingScene from './OnboardingScene';
import { OnbBody, OnbButton, OnbError, OnbEyebrow, OnbHeadline } from './OnboardingType';

// Screen 4 — Meet Arvexis. Strongest canonical Presence moment, then the real experience.
export const StepMeet = ({ copy: COPY, firstName, onStart, onSkipCompletion, onBack, isCompleting, error }) => (
  <OnboardingScene
    step={4}
    copy={COPY}
    align="end"
    desktopAlign="end"
    objectClass="object-[58%_center] lg:object-center"
    onBack={onBack}
    footer={
      <OnbButton onClick={onStart} disabled={isCompleting} testId="onboarding-start-conversation-btn">
        {COPY.meet.cta} <span aria-hidden="true">→</span>
      </OnbButton>
    }
  >
    <div className="lg:flex lg:items-end lg:gap-16">
      <div className="mb-[6.5rem] ml-[16%] flex justify-start lg:order-2 lg:mb-24 lg:ml-0 lg:w-[56%] lg:justify-center">
        <ArvexisPresence size="medium" state="idle" />
      </div>

      <div className="max-w-[20rem] lg:order-1 lg:w-[44%] lg:max-w-[42rem]">
        <OnbEyebrow testId="onboarding-ready-line" tight={COPY.tightEyebrow}>
          {firstName ? COPY.meet.readyNamed(firstName) : COPY.meet.ready}
        </OnbEyebrow>
        <OnbHeadline testId="onboarding-headline-4">{COPY.meet.headline}</OnbHeadline>
        <div className="mt-6 lg:mt-8 space-y-1.5">
          {COPY.meet.body.map((line) => (
            <OnbBody key={line}>{line}</OnbBody>
          ))}
        </div>
        {error && (
          <>
            <OnbError testId="onboarding-complete-error">{error}</OnbError>
            <button
              type="button"
              onClick={onSkipCompletion}
              className="mt-3 text-[0.78rem] text-white/50 underline underline-offset-4 transition-colors hover:text-white/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F0C987]"
              style={{ fontFamily: 'var(--font-display)' }}
              data-testid="onboarding-continue-without-saving-btn"
            >
              {COPY.meet.skip}
            </button>
          </>
        )}
      </div>
    </div>
  </OnboardingScene>
);

export default StepMeet;
